/**
 * Web Vitals reporting to GA4
 * Tracks Core Web Vitals: LCP, INP, CLS, FCP, TTFB
 */

const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ onCLS, onFCP, onLCP, onTTFB, onINP }) => {
      onCLS(onPerfEntry);   // Cumulative Layout Shift
      onFCP(onPerfEntry);   // First Contentful Paint
      onLCP(onPerfEntry);   // Largest Contentful Paint
      onTTFB(onPerfEntry);  // Time to First Byte
      onINP(onPerfEntry);   // Interaction to Next Paint
    });
  }
};

export default reportWebVitals;
